export const List = () => import("./List.vue");
export const Stock = () => import("./Stock.vue");
export const Groups = () => import("./Groups.vue");
export const DayBook = () => import("./DayBook.vue");
export const Dashboard = () => import("./Dashboard.vue");
export const OfficerBill = () => import("./OfficerBill.vue");
export const BalanceSheet = () => import("./BalanceSheet.vue");
export const ItemRevenue = () => import("./ItemRevenue.vue");
export const GroupLedger = () => import("./GroupLedger.vue");
export const AuditList = () => import("./Audit/DataTable.vue");
export const AuditSheet = () => import("./Audit/AuditSheet.vue");
export const MyBillDetails = () => import("./MyBillDetails.vue");
export const LedgerDetails = () => import("./LedgerDetails.vue");
export const MonthlyLedger = () => import("./MonthlyLedger.vue");
export const DisplayVoucher = () => import("./displayVoucher.vue");
export const ProductionCost = () => import("./ProductionCost.vue");
export const AuditStock = () => import("./Audit/StockDataTable.vue");
export const CompanyWiseBill = () => import("./CompanyWiseBill.vue");
export const AuditAsset = () => import("./Audit/AssetDataTable.vue");
export const LedgerEMIDetails = () => import("./LedgerEMIDetails.vue");
export const LedgerItemsDetails = () => import("./LedgerItemsDetails.vue");
export const AuditLedgerDetails = () => import("./AuditLedgerDetails.vue");
export const ItemsVoucherDetails = () => import("./ItemsVoucherDetails.vue");
export const MonthlySalePurchase = () => import("./MonthlySalePurchase.vue");
export const AuditSheetMonthly = () => import("./Audit/AuditSheetMonthly.vue");
export const YearlyLedger = () => import("./YearlyLedger.vue");
export const ProductionCostDetails = () => import("./ProductionCostDetails.vue");
export const LedgerTransactionDetails = () => import("./LedgerTransactionDetails.vue");
